module.exports = __webpack_public_path__ + "img/dbsLogoSmall.eb1e8565.png";